<template>
  <div id="search-job-container">
    <div class="search-place-container" ref="searchPlaceContainer">
      <div class="search-container" @click="onSearchContainerClick">
        <input
          class="search-keywords-place"
          type="search"
          v-model="placeKeywords"/>
        <span class="search-icon">
        <span class="icon"></span>
        <span class="search-placeholder" :style="placeholderStyle">
          <span class="search-text">{{ $t( 'common.search') }}</span>
        </span>
        </span>
      </div>
      <div class="search-types">
        <span
          v-if="company && url_name != 'job-list'"
          id="work-location"
          :class="active.location ? 'active-filter' : ''"
          @click="onLocationIconClick">
          <div class="icomoon-location"></div>
          {{ $t('jobFilter.label.location') }}
          <div class="icon"></div>
        </span>
      </div>
    </div>

    <div
      v-show="container.location"
      class="location-container need-hide-location"
      ref="locationContainer">
      <div class="scroll-content-wrapper" ref="scrollContent">
        <div class="cbd-filter-container">
          <div class="cbd-tabs">
            <a
              class="city-tab"
              :class="className.city.join(' ')"
              @click="onCbdTabClick('city')">
              <span class="text">{{ tab.city.isSelected ? tab.city.label : $t('jobFilter.location.city') }}</span>
              <span class="icon"></span>
            </a>
            <a
              class="region-tab"
              :class="className.region.join(' ')"
              @click="onCbdTabClick('region')">
              <span class="text">{{ tab.region.isSelected ? tab.region.label : $t('jobFilter.location.region') }}</span>
              <span class="icon"></span>
            </a>
            <a
              class="area-tab"
              :class="className.area.join(' ')"
              @click="onCbdTabClick('area')">
              <span class="text">{{ tab.area.isSelected ? tab.area.label : $t('jobFilter.location.area') }}</span>
              <span class="icon"></span>
            </a>
          </div>

          <div class="city-container" ref="cityContainer" v-show="container.city">
            <!-- add from js template id=filter-city-template -->
            <div class="loading loc-loading" v-show="loading.city"></div>
            <template v-if="!loading.city">
              <div class="current-city">
                <label>{{ $t('jobFilter.location.currentCity') }} : </label>
                <div class="location-message">
                  <p class="with-location" v-show="showWithLocation">
                    <span>{{ $t('jobFilter.location.yourLocation') }} : </span>
                    <span id="position-city" class="city-name" @click="onCityNameClick(currentPositionCity.id, currentPositionCity.name)">{{ currentPositionCity.name }}</span>
                  </p>

                  <p class="no-location" v-show="!showWithLocation">
                    <!-- {{ $t('Oops, we cannot locate you currently. Please select the city from the below list.') }} -->
                    {{ $t('jobFilter.location.noLocation') }}
                  </p>
                </div>
              </div>
              <div class="hot-city-list">
                <label>{{ $t('jobFilter.location.hotCities') }} : </label>
                <div class="hot-cities">
                  <span
                    class="city-name"
                    :class="active.cityId === 0 ? 'active-name' : ''"
                    @click="onCityNameClick(0, $t('jobFilter.location.allCities'))">{{ $t('jobFilter.location.allCities') }}</span>
                  <span
                    class="city-name"
                    v-for="(item, index) in hotCityList"
                    :key="index"
                    :class="active.cityId === item.id ? 'active-name' : ''"
                    @click="onCityNameClick(item.id, languageCode === 'en' ? item.text : item.cn_text)">
                    {{ languageCode === 'en' ? item.text : item.cn_text }}
                  </span>
                </div>
              </div>
              <div class="group-city-list">
                <label>{{ $t('jobFilter.location.allCities') }} : </label>
                <div class="letter-index">
                  <a
                    v-for="(letter, index) in letterIndex"
                    :key="index"
                    @click="onLetterIndexClick(letter)">
                    {{ letter }}
                  </a>
                </div>
                <div class="cities-container">
                  <div
                    :id="`city-${letter}`"
                    class="one-group"
                    v-for="(letter, index) in letterIndex"
                    :key="index">
                    <label>{{ letter }}</label>
                    <div class="group-cities">
                      <span
                        class="city-name"
                        v-for="(item, index) in groupCityList[letter]"
                        :key="index"
                        :class="active.cityId === item.id ? 'active-name' : ''"
                        @click="onCityNameClick(item.id, languageCode === 'en' ? item.text : item.cn_text)">
                        {{ languageCode === 'en' ? item.text : item.cn_text }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="region-container" v-show="container.region">
            <!-- add from js template id=filter-region-template -->
            <div class="loading loc-loading" v-show="loading.region"></div>
            <div class="region-list" v-show="!loading.region">
              <span
                class="region-name"
                :class="active.regionId === 0 ? 'active-name' : ''"
                @click="onReionNameClick(0, $t('jobFilter.location.allRegions'))">{{ $t('jobFilter.location.allRegions') }}</span>
              <span
                class="region-name"
                v-for="(item, index) in regionResults"
                :key="index"
                :class="active.regionId === item.id ? 'active-name' : ''"
                @click="onReionNameClick(item.id, languageCode === 'en' ? item.name : item.cn_name)">
                {{ languageCode === 'en' ? item.name : item.cn_name }}
              </span>
            </div>
          </div>
          <div class="area-container" v-show="container.area">
            <!-- add from js template id=filter-area-template -->
            <div class="loading loc-loading" v-show="loading.area"></div>
            <div class="area-list" v-show="!loading.area">
              <span
                class="area-name"
                :class="active.areaId === 0 ? 'active-name' : ''"
                @click="onAreaNameClick(0, $t('jobFilter.location.allAreas'))">{{ $t('jobFilter.location.allAreas') }}</span>
              <span
                class="area-name"
                v-for="(item, index) in areaResults"
                :key="index"
                :class="active.areaId === item.id ? 'active-name' : ''"
                @click="onAreaNameClick(item.id, languageCode === 'en' ? item.name : item.cn_name)">
                {{ languageCode === 'en' ? item.name : item.cn_name }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-btn-container">
        <span
          class="filter-btn "
          :class="disableFilterBtn ? 'disabled-btn' : ''"
          @click="onFilterBtnClick">{{ $t('common.btn.ok') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import Optional from 'optional-js'

const TYPE_SEARCH = '5'
const TYPE_FILTER_INDUSTRY = '1'
const TYPE_FILTER_SALARY = '2'
const TYPE_FILTER_WORK_TIME = '3'
const TYPE_FILTER_LOACTION = '4'
const TYPE_FILTER_ROLE_TYPE = '6'
const TYPE_ALL = '0' // both searh and filter
export default {
  props: {
    search: {
      type: Object,
      required: true
    },
    has_custom_mobile_landing_page: {
      type: Boolean,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    url_name: {

    },
    searchOverlay: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hotCityList: [],
      letterIndex: [],
      groupCityList: [],
      regionResults: [],
      areaResults: [],
      cacheObj: {
        parentIndustryCache: null,
        jobTypesCache: null,
        salaryCache: null,
        workTimeCache: null,
        locationCache: {
          city: null,
          hotCity: null
        }
      },

      currentPositionCity: {
        id: null,
        name: null
      },
      showWithLocation: false,
      active: {
        location: false,
        cityId: null,
        regionId: null,
        areaId: null
      },
      tab: {
        city: {
          isSelected: false,
          label: null
        },
        region: {
          isSelected: false,
          label: null
        },
        area: {
          isSelected: false,
          label: null
        }
      },
      className: {
        city: [],
        region: [],
        area: []
      },
      container: {
        location: false,
        city: false,
        region: false,
        area: false
      },
      loading: {
        city: false,
        region: false,
        area: false
      },
      disableFilterBtn: true,
      placeKeywords: null
    }
  },
  computed: {
    placeholderStyle () {
      if (this.search.keywords) {
        return 'display: none;'
      } else {
        return 'display: inline;'
      }
    },
    languageCode () {
      return this.$i18n.locale
    }
  },
  created () {
    const currentCity = JSON.parse(sessionStorage.getItem('current_city'))
    if (currentCity) {
      this.currentPositionCity.id = currentCity.id
      this.currentPositionCity.name = currentCity.cn_name
    }
    // this.initClassName()

    this.placeKeywords = this.search.keywords
    this.searchOverlay.onClose = () => {
      this.switchActive()
      this.switchContainer()
      this._showHideMask(false, TYPE_ALL)
      this.placeKeywords = this.search.keywords
      // this.$emit('fetchJobList')
      document.body.style.overflow = 'auto'
    }
  },
  mounted () {
    this.init()

    const url = window.location.href
    if (url.indexOf('#') > -1) {
      const hashParams = url.split('#')[1].split('&')
      if (hashParams.indexOf('trigger_city=1') > -1) {
        // if (utils.getHashValueByParam('trigger_city') == 1) {
        // $('#work-location').trigger('click')
        this.onLocationIconClick()
        // }
      }
    }
  },
  methods: {
    ...mapActions('job', [
      'getCurrentCityByIp',
      'getWorkLocationCitys',
      'getSonIndustry',
      'getParentIndustry',
      'getJobRegions',
      'getJobAreas'
    ]),
    ...mapGetters('account', ['getCurrentAccount']),

    // init
    init () {
      this.initClassName()

      this._initJobDetailPageStatus() // at here call the _showCompanyPage is wrong
      this._autoRenderCBD()
      this.getGeolocation(() => {
        this.$emit('fetchJobList')
      })
      this.active.cityId = this.search.areaCityId || null
      this.active.regionId = this.search.areaRegionId || null
      this.active.areaId = this.search.areaId || null
    },
    // init
    initClassName () {
      this.className.city.push('selected-tab')
      this.tab.city.isSelected = true
      this.tab.city.label = this.$t('jobFilter.location.city')
    },
    _initJobDetailPageStatus () {
      const isCompanyAccor = false
      if (window.location.href.indexOf('#') === -1 && !isCompanyAccor) {
        this._showCompanyPage(1)
      } else {
        this._showCompanyPage(2)
      }
    },
    getGeolocation (callback) {
      navigator.geolocation.getCurrentPosition(position => {
        this.search.lng = position.coords.longitude
        this.search.lat = position.coords.latitude
        callback()
      }, () => {
      // alert('get location error');
      // error.code: 3 (timeout) 2: googleapi call 404 1: not allowed
        callback()
      }, {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 1000
      })
    },
    _autoRenderCBD () {
      if (_.isEmpty(this._getHistoryCBD())) {
        this._getWorkLocationCitys()
      }
    },

    switchActive (name) {
      if (name) {
        if (this.active[name]) {
          this.active[name] = false
        } else {
          this.active[name] = true
        }
      }
      for (const key in this.active) {
        if (key !== name) {
          if (typeof this.active[key] === 'boolean' || key.indexOf('Id') < 0) {
            this.active[key] = false
          }
        }
      }
    },

    switchContainer (name) {
      if (name) {
        this.container[name] = !this.container[name]
      } else {
        for (const key in this.container) {
          this.container[key] = false
        }
      }
    },
    _setSearchPostionCustomed () {
      const location = this.$refs.locationContainer
      const body = document.body
      const height = body.clientHeight - 100
      location.style.height = height + 'px'
      location.style.position = 'fixed'
      location.style.top = '100px'
    },

    _showHideMask (isShow, type) {
      const isAppleCompany = this.company.id === 87
      const isCompanyInfo = false // TODO need computed, is always false now with jobList page
      if (isCompanyInfo && isAppleCompany) {
        return false
      }
      if (isShow) {
        // $('#search-mask').show()
        this.searchOverlay.show = true
        // $('.need-hide').hide()
        this.switchContainer()
        // $('#search-mask').css('z-index', 1000)
        this.searchOverlay.zIndex = 1000
        if (type === TYPE_SEARCH) {
          // $('.search-types > span').removeClass('active-filter')
          this.switchActive()
          // $('#search-mask').css('z-index', 10000)
          this.searchOverlay.zIndex = 10000
          // $inputKeywords.val($('.search-keywords-place').val())
          this.$emit('setkeywords', this.placeKeywords)
          this.showSearchForm = true
          this.$emit('showSearchForm', true)
          // $inputKeywords.focus()
          // this.$refs.searchKeywords.focus()
          this.$nextTick(() => {
            document.querySelector('.search-keywords').focus()
          })
        } else if (type === TYPE_FILTER_INDUSTRY) {
          this.container.jobType = true
        } else if (type === TYPE_FILTER_SALARY) {
          this.container.salary = true
        } else if (type === TYPE_FILTER_WORK_TIME) {
          this.container.workTime = true
        } else if (type === TYPE_FILTER_LOACTION) {
          this.container.location = true

          this.container.city = false
          this.container.region = false
          this.container.area = false
          if (this.active.cityId && this.active.cityId !== 0) {
            this.container.region = true
          } else if (this.active.regionId && this.active.regionId !== 0) {
            this.container.area = true
          } else {
            this.container.city = true
          }
        } else if (type === TYPE_FILTER_ROLE_TYPE) {
          this.container.roleType = true
        }
        if (this.company.id === 2435) {
          document.getElementById('main')[0].style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'hidden'
        }
      } else {
        // $('.search-types > span').removeClass('active-filter')
        // this.active.hideAll
        this.switchContainer()
        this.switchActive()
        // $('#search-mask').hide()
        this.searchOverlay.show = false
        if (type === TYPE_SEARCH) {
          // $('.search-keywords-place').val($inputKeywords.val())
          // if (this.search.keywords) {
          //   $('.search-placeholder').hide()

          // } else {
          //   $('.search-placeholder').show()
          // }
          // TODO search-placeholder is in HoneywellFilter
        }
        // only in company-detail-new page, we remove the mask. So the search form should always show.
        // if (!this.isCompanyAccor) { // not company accor
        // TODO chech isCompanyAccor is always false ???
        if (isCompanyInfo && isAppleCompany) {
          // $('#search-form').show()
          this.showSearchForm = true
          this.$emit('showSearchForm', true)
        } else {
          // $('#search-form').hide()
          this.showSearchForm = false
          this.$emit('showSearchForm', false)
        }
        // }
        if (this.company.id === 2435) {
          document.getElementById('main')[0].style.overflow = 'auto'
        } else {
          document.body.style.overflow = 'auto'
        }
      }
    },

    _getHistoryCBD () {
      const CBDInfo = JSON.parse(sessionStorage.getItem('cbd'))
      if (CBDInfo) {
        return {
          city: CBDInfo.city,
          region: CBDInfo.region,
          area: CBDInfo.area
        }
      }
      return null
    },

    _setHistoryCBD (cityId, regionId, areaId) {
      const CBDInfo = {
        city: cityId,
        region: regionId,
        area: areaId
      }
      sessionStorage.setItem('cbd', JSON.stringify(CBDInfo))
    },

    _customizedLanguage () {
      const currentCompany = this.company
      const rootCompanyId = currentCompany.root_company && currentCompany.root_company.id
      const customized = {
        language_code: '',
        only_root_company: ''
      }
      if (currentCompany) {
        if ([2435].indexOf(currentCompany.id) !== -1) { // accor
          customized.language_code = 'zh-cn'
        }
      }
      if (rootCompanyId && ([2435].indexOf(rootCompanyId) !== -1)) { // customized accor son company
        customized.only_root_company = 1
      }
      return customized
    },

    _setFilterBtnStatus () {
      if (this.className.city.indexOf('delete-tab') > -1 ||
        this.className.region.indexOf('delete-tab') > -1 ||
        this.className.area.indexOf('delete-tab') > -1) {
        this.disableFilterBtn = false
      } else {
        this.disableFilterBtn = true
      }
    },

    setSearchParams () {
      const parentIndustryId = this.active.parentIndustryId
      const sonIndustryId = this.active.sonIndustryId
      const salaryId = this.active.salaryId
      const workTimeId = this.active.workTimeId
      const roleTypeId = this.active.roleTypeId
      const cityId = this.active.cityId
      const regionId = this.active.regionId
      const areaId = this.active.areaId
      const refj = this.search.refj
      let orderBy = null
      if (this._isCandidateViewRefJobs(refj)) {
        if (this.className.innerSwitchIcon.indexOf('updated-time-icon') > -1) {
          orderBy = 'time_desc'
        } else {
          orderBy = 'earning_desc'
        }
      }

      this.search.jobIndustryId = parentIndustryId || 0
      this.search.jobTypeId = sonIndustryId || 0
      this.search.jobSalaryId = salaryId === 0 ? null : salaryId
      this.search.jobWorkTimeId = workTimeId === 0 ? null : workTimeId
      this.search.roleType = roleTypeId === 0 ? null : roleTypeId
      this.search.areaCityId = cityId
      this.search.areaRegionId = regionId
      this.search.areaId = areaId
      this.search.orderBy = orderBy
    },

    _commonFilterListAction (customized) {
      // this.setHashParams(customized)
      // need setSearchParams
      this.setSearchParams()
      // this._showCompanyPage(2) always is 2 with jobList page, move it to ListSearch and jobList page created()
      this.$emit('fetchJobList', false, customized)

      this._showHideMask(false, TYPE_ALL)
    },

    _showCompanyPage (page) {
      // _showCompanyPage at init method === need call after company api response
      // page=1 --> company job page,
      // page=2 --> company job search page
      if (!this.has_custom_mobile_landing_page) {
        if (page === 1) {
          // $('.more-jobs-wrapper').removeClass('hide')
          this.$emit('showWrapper', { 'more-jobs-wrapper': true, 'company-job-list-wrapper': false })
        } else if (page === 2) {
          // $('.company-job-list-wrapper').removeClass('hide')
          // $('.more-jobs-wrapper').addClass('hide')
          this.$emit('showWrapper', { 'more-jobs-wrapper': false, 'company-job-list-wrapper': true })
        }
      } else {
        this.$emit('showWrapper', { 'company-job-list-wrapper': true })
      }
    },

    _isCandidateViewRefJobs (refj) {
      // return refj && !($('#employee-account-flag').val() === '1')
      return refj && !(this.getCurrentAccount.employee)
    },

    _fetchJobList () {
      if (this.has_custom_mobile_landing_page) {
        this.search.keywords = this.placeKeywords
        this.setSearchParams()
        this.$emit('fetchJobList', false, 'customized')
      }
    },
    /**
     * will send request with api
     */
    async _getCurrentCityByIp () {
      let currentCity = JSON.parse(sessionStorage.getItem('current_city'))
      let cityName
      if (currentCity) {
        if (!_.isEmpty(currentCity)) {
          cityName = this.languageCode === 'en' ? currentCity.name : currentCity.cn_name
          // $('#position-city').text(cityName).attr('data-id', currentCity.id).data('cn_name', currentCity.cn_name)
          this.currentPositionCity.id = currentCity.id
          this.currentPositionCity.name = cityName
          this.showWithLocation = true
          if (_.isEmpty(this._getHistoryCBD()) && currentCity.id) {
            this.onCityNameClick(currentCity.id, cityName, true)
          }
        } else {
          this.showWithLocation = false
        }
      } else {
        const resp = Optional.ofNullable(await this.getCurrentCityByIp()).map(item => item).orElse({})
        if (resp && !_.isEmpty(resp.current_city)) {
          currentCity = resp.current_city
          sessionStorage.setItem('current_city', JSON.stringify(currentCity))
          const cityName = this.languageCode === 'en' ? currentCity.name : currentCity.cn_name
          this.currentPositionCity.id = currentCity.id
          this.currentPositionCity.name = cityName
          this.showWithLocation = true
          if (_.isEmpty(this._getHistoryCBD()) && currentCity.id) {
            // $($('.city-name[data-id=' + currentCity.id + ']')[0]).trigger('click')
            this.onCityNameClick(currentCity.id, cityName, true)
          }
        } else {
          this.showWithLocation = false
        }
      }
    },
    async _getWorkLocationCitys () {
      /** ***special logic for customized company *******/
      const customizedInfo = this._customizedLanguage()
      const languageCode = customizedInfo.language_code
      /** ***special logic for customized company *******/
      this.loading.location = true
      try {
        const resp = Optional.ofNullable(await this.getWorkLocationCitys(languageCode)).map(item => item).orElse({})
        if (resp.total > 0) {
          const cacheObj = this.cacheObj
          cacheObj.locationCache.hotCity = resp.hotCityList
          cacheObj.locationCache.city = resp.groupCityList
          let letterIndex = []
          _.each(cacheObj.locationCache.city, (item, key) => {
            letterIndex.push(key)
          })
          letterIndex = _.sortBy(letterIndex, letter => letter)
          this.letterIndex = letterIndex
          this.hotCityList = cacheObj.locationCache.hotCity
          this.groupCityList = cacheObj.locationCache.city

          this._getCurrentCityByIp()
          const historyCBD = this._getHistoryCBD()
          if (historyCBD && (historyCBD.city || historyCBD.city === 0)) {
            // when there is hot cities $('.city-name[data-id=' + _getHistoryCBD().city + ']').length == 2
            // $($('.city-name[data-id=' + historyCBD.city + ']')[0]).trigger('click')
            this.onCityNameClick(historyCBD.city, null, true)
          }
        } else {
          // alert(resp.code);
        }
      } finally {
        this.loading.location = false
      }
    },
    async _getJobRegions (cityId) {
      if (!cityId || cityId === 0) {
        return
      }
      this.loading.region = true
      try {
        const resp = Optional.ofNullable(await this.getJobRegions(cityId)).map(item => item).orElse({})
        if (resp && resp.code === 0) {
          // templateStr = _.template($('#filter-region-template').html(), { results: resp.data })
          // $regionContainer.html(templateStr)
          this.regionResults = resp.data
          const historyCBD = this._getHistoryCBD()
          if (historyCBD && (historyCBD.region || historyCBD.region === 0)) {
            // $('.region-name[data-id=' + historyCBD.region + ']').trigger('click')
            this.onReionNameClick(historyCBD.region, null, true)
          }
        } else {
          // alert(resp.code);
        }
      } finally {
        this.loading.region = false
      }
    },
    async _getJobAreas (regionId) {
      if (!regionId || regionId === 0) {
        return
      }
      this.loading.region = true
      try {
        const resp = Optional.ofNullable(await this.getJobAreas(regionId)).map(item => item).orElse({})
        if (resp && resp.code === 0) {
          // templateStr = _.template($('#filter-area-template').html(), { results: resp.data })
          // $areaContainer.html(templateStr)
          this.areaResults = resp.data
          const historyCBD = this._getHistoryCBD()
          if (historyCBD && (historyCBD.area || historyCBD.area === 0)) {
            this.onAreaNameClick(historyCBD.area, null, true)
          }
        } else {
          // alert(resp.code);
        }
      } finally {
        this.loading.region = false
      }
    },
    /**
     * event: onXXXClick
     */
    onLocationIconClick () {
      const cacheObj = this.cacheObj
      const locationContainer = this.$refs.locationContainer
      if (this.has_custom_mobile_landing_page) {
        document.body.scrollTop = 300
        if (locationContainer.style.position !== 'fixed') {
          this._setSearchPostionCustomed()
        }
      } else if (!locationContainer.style.height) {
        // set_maxHeight
        const otherElementHeight = document.querySelector('.company-job-list-wrapper').clientHeight
        const maxHeight = document.body.clientHeight - otherElementHeight
        locationContainer.style.height = maxHeight + 'px'
      }
      // $('.search-types > span:not("#' + this.id + '")').removeClass('active-filter')
      // $(this).toggleClass('active-filter')
      this.switchActive('location')
      if (this.active.location) {
        if (cacheObj.locationCache.city && cacheObj.locationCache.hotCity) {
          this.container.location = true
          this._getCurrentCityByIp()
        } else {
          this._getWorkLocationCitys()
        }
        this._showHideMask(true, TYPE_FILTER_LOACTION)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    onSearchContainerClick () {
      if (!this.has_custom_mobile_landing_page) {
        this._showHideMask(true, TYPE_SEARCH)
      }
    },

    onLetterIndexClick (letter, $event) {
      // let $container = $('.scroll-content-wrapper')
      // let target = $(this).data('href')
      // $container.scrollTo(target)

      const height = document.getElementById(`city-${letter}`).offsetTop
      this.$refs.scrollContent.scrollTo({ top: height })
    },

    onCityNameClick (cityId, cityName, isAutoClick) {
      if (!cityName) {
        if (cityId === 0) {
          cityName = this.$t('jobFilter.location.allCities')
        } else {
          const hotCity = this.hotCityList.find(item => item.id === cityId)
          if (hotCity) {
            cityName = this.languageCode === 'en' ? hotCity.text : hotCity.cn_text
          } else {
            let city = null
            for (const key in this.groupCityList) {
              city = this.groupCityList[key].find(item => item.id === cityId)
              if (city && city.id) {
                break
              }
            }
            if (city) {
              cityName = this.languageCode === 'en' ? city.text : city.cn_text
            }
          }
        }
      }
      this.active.cityId = cityId
      this._getJobRegions(cityId)
      // $cityContainer.hide()
      // $regionContainer.show()
      this.container.city = false
      this.container.region = true
      if (cityId === 0) {
        if (isAutoClick) {
          this.container.city = true
        } else {
          this.onFilterBtnClick()
        }
      } else {
        // change tab text
        _.remove(this.className.city, item => item === 'selected-tab')
        this.className.city.push('delete-tab')
        this.tab.city.isSelected = true
        this.tab.city.label = cityName
        this.className.region.push('selected-tab')
        this._setFilterBtnStatus()
      }
      if (isAutoClick) {
        this.container.region = false
      }
    },

    onReionNameClick (regionId, regionName, isAutoClick) {
      if (!regionName) {
        if (regionId === 0) {
          regionName = this.$t('jobFilter.location.allRegions')
        } else {
          const region = this.regionResults.find(item => item.id === regionId)
          regionName = this.languageCode === 'en' ? region.name : region.cn_name
        }
      }
      this.active.regionId = regionId
      this._getJobAreas(regionId)
      this.container.city = false
      this.container.region = false
      this.container.area = true

      if (regionId === 0) {
        if (isAutoClick) {
          this.container.region = true
        } else {
          // this.onCbdTabClick('region')
          this.onFilterBtnClick()
          // TODO check may have problem
        }
      } else {
        // change tab text
        _.remove(this.className.region, item => item === 'selected-tab')
        this.className.region.push('delete-tab')
        this.className.area.push('selected-tab')
        this.tab.region.isSelected = true
        this.tab.region.label = regionName
        this._setFilterBtnStatus()
      }
    },

    onAreaNameClick (areaId, areaName, isAutoClick) {
      if (!areaName) {
        if (areaId === 0) {
          areaName = this.$t('jobFilter.location.allAreas')
        } else {
          const area = this.areaResults.find(item => item.id === areaId)
          if (area) {
            areaName = this.languageCode === 'en' ? area.name : area.cn_name
          }
        }
      }
      const preAreaId = this.active.areaId
      this.active.areaId = areaId
      if (areaId === 0) {
        if (preAreaId && preAreaId !== areaId) {
          // this.onCbdTabClick('area')
          this.onAreaNameClick(areaId, areaName, true)
          return false
        }
        if (!isAutoClick) {
          this.onFilterBtnClick()
        }
      } else {
        // change tab text
        _.remove(this.className.area, item => item === 'selected-tab')
        this.className.area.push('delete-tab')
        this.tab.area.isSelected = true
        this.tab.area.label = areaName
        this._setFilterBtnStatus()
      }
    },

    onCbdTabClick (type) {
      if ((this.className[type].indexOf('delete-tab') < 0)) {
        return
      }
      if (type === 'region' && (this.active.cityId && this.active.cityId === 0)) {
        return
      }
      if (type === 'area' && (this.active.regionId && this.active.regionId === 0)) {
        return
      }

      _.remove(this.className.city, item => item === 'selected-tab')
      _.remove(this.className.region, item => item === 'selected-tab')
      _.remove(this.className.area, item => item === 'selected-tab')
      this.container.city = false
      this.container.region = false
      this.container.area = false

      let CBDInfo = this._getHistoryCBD() || {}
      if (type === 'city') {
        _.remove(this.className.city, item => item === 'delete-tab')
        _.remove(this.className.region, item => item === 'delete-tab')
        _.remove(this.className.area, item => item === 'delete-tab')
        this.tab.city.isSelected = false
        this.tab.city.label = this.$t('jobFilter.location.city')
        this.tab.region.isSelected = false
        this.tab.region.label = this.$t('jobFilter.location.region')
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.active.cityId = null
        this.active.regionId = null
        this.active.areaId = null

        this.className.city.push('selected-tab')
        this.container.city = true
        CBDInfo = {}
      } else if (type === 'region') {
        _.remove(this.className.region, item => item === 'delete-tab')
        _.remove(this.className.area, item => item === 'delete-tab')
        this.tab.region.isSelected = false
        this.tab.region.label = this.$t('jobFilter.location.region')
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.active.regionId = null
        this.active.areaId = null
        this.className.region.push('selected-tab')
        this.container.region = true
        CBDInfo.region = null
        CBDInfo.area = null
      } else if (type === 'area') {
        _.remove(this.className.area, item => item === 'delete-tab')
        this.active.areaId = null
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.className.area.push('selected-tab')
        this.container.area = true
        CBDInfo.area = null
      }
      sessionStorage.setItem('cbd', JSON.stringify(CBDInfo))
      this._setFilterBtnStatus()
    },

    onFilterBtnClick () {
      const cityId = this.active.cityId
      const regionId = this.active.regionId
      const areaId = this.active.areaId
      if (cityId === null && !regionId && !areaId) {
        return
      }

      this._setHistoryCBD(cityId, regionId, areaId)
      this._commonFilterListAction()
    },

    onClearSearchClick () {
      // _clearFilters()
      this.placeKeywords = null
      this.active.cityId = null
      this.active.regionId = null
      this.active.areaId = null
      this.onCbdTabClick('city')
      sessionStorage.removeItem('cbd')
      this.$emit('clearSearch')
    }
  },
  watch: {
    company (value) {
      this._initJobDetailPageStatus()
    }
  }
}
</script>

<style lang="scss" scoped>
.cbd-filter-container {
  .cbd-tabs span.text {
    // vertical-align: baseline;
  }

  .group-city-list .letter-index a {
    margin-bottom: -2px;
  }

  .hot-city-list {
    word-break: break-all;
    word-wrap: break-word;
    .hot-cities {
      .city-name {
        display: inline-block;
      }
    }
  }

  .hot-city-list .hot-cities, .group-city-list .group-cities, .region-list, .area-list {
    span {
      margin-bottom: -2px;
    }
  }
}
</style>
